import React from 'react'
import { generatePath } from 'react-router-dom'
import { FormReadonlySelectField } from '@/components/Form/FormField'
import { links } from '@/utils/featureToggles'

interface Props {
  name: string
  label: React.ReactNode
  value?: string
  placeholder?: string
  onSelect(): void
  dataTest?: string
}

export const TradingAccountsPickerField: React.FC<Props> = ({
  name,
  label,
  value,
  placeholder,
  onSelect,
  dataTest = 'select-trading-account-button',
}) => {
  return (
    <FormReadonlySelectField
      name={name}
      label={label}
      placeholder={placeholder}
      value={value}
      dataTest={dataTest}
      onClick={onSelect}
      link={
        value
          ? generatePath(links.recordsClients.detailsUrl as string, {
              id: value,
              slug: 'details',
            })
          : undefined
      }
    />
  )
}
